import {
  SET_PORTAL_API, SET_PORTAL_SLIDESHOW, SET_PORTAL_BUTTONS,
  SET_PORTAL_CONFIRM, RESET_PORTAL, INCREMENT_SLIDE, DECREMENT_SLIDE,
  SET_PORTAL_EDIT_ORDER
} from "../actions/portal_actions";
import { Portal } from "../../utils/constants";


const initialState = {
  portalType: Portal.Empty,
  typeConfirm: null,
  typeEditOrder: null,
  portalVisible: false,
  title: '',
  text: '',
  images: [],
  index: 0,
  firm: {},
  customer: {},
  productObj: {},
  buttons: null,
  order: {},
  data: {}
}

export const portalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PORTAL_API: {
      return {
        ...state,
        portalType: Portal.ApiResult,
        portalVisible: true,
        title: action.title,
        text: action.text
      }
    }
    case SET_PORTAL_SLIDESHOW: {
      return {
        ...state,
        portalType: Portal.Slideshow,
        portalVisible: true,
        images: [...action.images],
        index: action.index
      }
    }
    case DECREMENT_SLIDE: {
      return {
        ...state,
        index: (state.index === 0 ? state.images.length - 1 : state.index - 1)
      }
    }
    case INCREMENT_SLIDE: {
      return {
        ...state,
        index: (state.index === state.images.length - 1 ? 0 : state.index + 1)
      }
    }
    case SET_PORTAL_CONFIRM: {
      return {
        ...state,
        portalType: Portal.Confirm,
        typeConfirm: action.typeConfirm,
        portalVisible: true,
        title: action.title,
        text: action.text,
        firm: action.firm,
        customer: action.customer,
        productObj: action.productObj,
        order: action.order,
        data: action.data
      }
    }
    case SET_PORTAL_BUTTONS: {
      return {
        ...state,
        portalType: Portal.Buttons,
        portalVisible: true,
        title: action.title,
        buttons: action.buttons
      }
    }
    case SET_PORTAL_EDIT_ORDER: {
      return {
        ...state,
        portalType: Portal.EditOrder,
        typeEditOrder: action.typeEditOrder,
        portalVisible: true,
        title: action.title,
        text: null,
        typeConfirm: null,
        order: action.order,
        customer: action.customer
      }
    }
    case RESET_PORTAL: {
      return {
        ...state,
        portalType: Portal.Empty,
        portalVisible: false,
        title: '',
        text: '',
        images: [],
        index: 0,
        firm: {},
        customer: {},
        productObj: {},
        typeConfirm: null,
        typeEditOrder: null,
        order: {},
        data: {}
      }
    }
    default: return state;
  }
}
